import { render } from "./PromoAssets.vue?vue&type=template&id=4ded1697"
import script from "./PromoAssets.vue?vue&type=script&lang=js"
export * from "./PromoAssets.vue?vue&type=script&lang=js"

import "./PromoAssets.vue?vue&type=style&index=0&id=4ded1697&scope=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__